import './lib/jquery'
import I18n from './lib/i18n'

document.addEventListener('DOMContentLoaded', () => {
  const currentData = $('#uploadForm').serialize()

  function bindOnbeforeunload(data) {
    window.onbeforeunload = function (e) {
      if (data !== $('#uploadForm').serialize()) {
        e.preventDefault()
        e.returnValue = I18n.t('upload-form.confirm_leave')
      }
    }
  }
  bindOnbeforeunload(currentData)

  function saveForm(goTo) {
    window.onbeforeunload = function () {}
    $.ajax({
      type: 'PATCH',
      data: $('#uploadForm').serialize(),
      url: `${$('#uploadForm').attr('action')}/update_js`,
      success: () => {
        window.onbeforeunload = function () {}
        window.location = goTo
      },
      error: () => {
        // eslint-disable-next-line no-restricted-globals, no-alert
        if (confirm(I18n.t('uploads.upload-form.auto_save_failed'))) {
          bindOnbeforeunload(currentData)
          window.location = goTo
        }
      }
    })
  }

  $('.auto-save-delayed').click(function (e) {
    e.preventDefault()
    const goTo = this.getAttribute('href')
    const newData = $('#uploadForm').serialize()
    if (newData !== currentData) {
      saveForm(goTo)
    } else {
      window.location.assign(goTo)
    }
  })

  $('.save-button').click(() => {
    window.onbeforeunload = function () {}
  })
})
